/**
 * Product Detail - Image gallery and quantity selector
 */

(function() {
  'use strict';

  function initProductDetail(section) {
    const imageArea = section.querySelector('.product-detail-image-area');
    if (!imageArea) return;

    const sectionId = imageArea.dataset.sectionId;
    const mainImage = imageArea.querySelector('.product-detail-main-image');
    const thumbnails = imageArea.querySelectorAll('.product-detail-thumbnails img');
    const decreaseBtn = section.querySelector(`.product-detail-decrease-qty[data-section-id="${sectionId}"]`);
    const increaseBtn = section.querySelector(`.product-detail-increase-qty[data-section-id="${sectionId}"]`);
    const quantityValue = section.querySelector(`.product-detail-quantity-value[data-section-id="${sectionId}"]`);
    const quantityInput = section.querySelector(`.product-detail-quantity-input[data-section-id="${sectionId}"]`);

    // Thumbnail click handler
    if (thumbnails.length && mainImage) {
      thumbnails.forEach(thumb => {
        thumb.addEventListener('click', () => {
          const newSrc = thumb.dataset.srcMain || thumb.dataset.src || thumb.src;
          
          // Remove active class from all thumbnails
          thumbnails.forEach(t => t.classList.remove('active'));
          // Add active class to clicked thumbnail
          thumb.classList.add('active');

          // Fade out main image
          if (mainImage) {
            mainImage.style.opacity = '0';
            setTimeout(() => {
              mainImage.src = newSrc;
              mainImage.style.opacity = '1';
            }, 150);
          }
        });
      });
    }

    // Quantity controls
    if (decreaseBtn && increaseBtn && quantityValue) {
      decreaseBtn.addEventListener('click', () => {
        let qty = parseInt(quantityValue.textContent) || 1;
        if (qty > 1) qty--;
        quantityValue.textContent = qty;
        if (quantityInput) quantityInput.value = qty;
      });

      increaseBtn.addEventListener('click', () => {
        let qty = parseInt(quantityValue.textContent) || 1;
        qty++;
        quantityValue.textContent = qty;
        if (quantityInput) quantityInput.value = qty;
      });
    }
  }

  // Initialize all product detail sections
  function initAllProductDetails() {
    const sections = document.querySelectorAll('.product-detail-section');
    sections.forEach(section => {
      initProductDetail(section);
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllProductDetails);
  } else {
    initAllProductDetails();
  }

  // Re-initialize on Shopify section load
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.detail.querySelector('.product-detail-section');
      if (section) {
        initProductDetail(section);
      }
    });
  }
})();
